var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:[{
    'no-bordered': _vm.noBordered,
    'btn-loading': _vm.busy,
    'clickable': _vm.clickable,
  }],attrs:{"disabled":_vm.busy,"variant":_vm.variant},on:{"click":_vm.click}},[(!_vm.busy)?[_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }